import mapActions from './mapActions';

export default mapActions('building_running_performances', {
    fetchAll_url: data => `/api/buildings/${data.building_id}/running_performances`
});